module.exports = __webpack_public_path__ + "img/185.793d66e6.jpg";